import * as MetaReducers from './check-in.metareducer';
import * as Reducers from './check-in.reducers';

export const CheckInReducers = {
  MetaReducers,
  Reducers,
};
